import {Backdrop, CircularProgress} from '@mui/material'
import {useGlobalStates} from '../../contexts/GlobalStatesContext'

export default () => {
    const {loading} = useGlobalStates()

    return (
        <Backdrop sx={theme => ({zIndex: theme.zIndex.tooltip + 1})} open={loading}>
            <CircularProgress sx={theme => ({color: theme.palette.success.light})} size={50} />
        </Backdrop>
    )
}
